import {equals} from 'ramda';

import {aiAssistantContextStore} from '@dms/ai-assistant';
import type {MenuDynamicAccessKey, Register} from '@dms/api/shared';

import {dmsRouteCatalogPaths, filterReachableRouteIds} from 'features/dms-route-catalog';

/**
 * Publishes the permission-filtered route IDs, skipping the patch when nothing changed. The store
 * replaces its snapshot and notifies every subscriber unconditionally, and the caller re-runs
 * whenever the register identity changes (permission refetches cycle through `null`), so an
 * equality gate here keeps deep-equal republishes from re-rendering assistant consumers. Same
 * guard the sibling producers use (`useAssistantEntityContext`).
 */
export function syncReachableRouteIds(
  register: Pick<Register, 'reachableRoutePaths'>,
  dynamicAccess: Record<MenuDynamicAccessKey, boolean>
) {
  const reachableRouteIds = filterReachableRouteIds(
    dmsRouteCatalogPaths,
    register.reachableRoutePaths,
    dynamicAccess
  );

  if (equals(aiAssistantContextStore.getContext().reachableRouteIds, reachableRouteIds)) {
    return;
  }

  aiAssistantContextStore.patchContext({reachableRouteIds});
}
